import React from "react";
import { Link } from "react-router-dom";
import style from "./PageAccessDenied.module.css";
import pageNotFound from "../../assets/images/page-not-found.png";
import history from "../../utils/history";

function PageAccessDenied() {
  const redirectLogin = () => {
    history.push("/");
  };

  let loggedIn = !!(JSON.parse(localStorage.getItem("USER_INFO")) && 
   JSON.parse(localStorage.getItem("USER_INFO")).token);
  if(!loggedIn){
    history.push("/");
  }

  return (
    <div className={style.PageAccessDeniedWrapper}>
          <div className="row">
              <div className="col-md-12">
                <h3>Page Access Denied!</h3>
              </div>
            </div>
          <div className="row">
                <div className="col-md-12">
                  <p>
                  You do not have access to this page.
                  </p>
                </div>
           </div>
    </div>
  );
}

export default PageAccessDenied;
